import { Dialog, DialogContent, DialogDescription, DialogHeader } from "@/components/ui/dialog"
import { SheetDetails } from "@/interface/dataInterface"
import { DialogTitle } from "@radix-ui/react-dialog"
import { Dispatch, FC, PropsWithChildren, SetStateAction } from "react"

interface Props extends PropsWithChildren {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title: string;
  description?: string;
}

const CommonDetailsDialog: FC<Props> = ({open, setOpen, title, description, children}) => {
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent className="max-w-sm">
                <DialogHeader>
                    <DialogTitle className="text-2xl font-bold">{title}</DialogTitle>
                    {description && <DialogDescription>{description}</DialogDescription>}
                </DialogHeader>
                {children}
            </DialogContent>
        </Dialog>
    )
}

export default CommonDetailsDialog